module.exports = "#room-name-progress-bar{width:10%}\n"